"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("./client");
function createInstance(config) {
    return new client_1.OADAClient(config);
}
exports.createInstance = createInstance;
async function connect(config) {
    return new client_1.OADAClient(config);
}
exports.connect = connect;
var client_2 = require("./client");
exports.OADAClient = client_2.OADAClient;
//# sourceMappingURL=index.js.map